<div class="listino-container">
  <div class="chain-banner" *ngIf="showChainBanner">
    <div class="chain-banner-text">
      <strong>{{ "profile.listino_chain_title" | translate }}</strong>
      <p>{{ "profile.listino_chain_text" | translate }}</p>
    </div>
    <div class="chain-banner-actions">
      <button class="btn-gold" (click)="goHome()">
        {{ "profile.listino_chain_home_btn" | translate }}
      </button>
      <button class="chain-banner-close" (click)="dismissBanner()" aria-label="close">✕</button>
    </div>
  </div>

  <div class="listino-header">
    <div>
      <h1 class="listino-title">{{ "profile.services_list_title" | translate }}</h1>
      <p class="listino-subtitle">{{ "profile.services_list_desc" | translate }}</p>
    </div>
    <button class="btn-gold listino-add" (click)="addService()" *ngIf="!loadError && services.length > 0">
      <app-icon name="plus" [size]="16"></app-icon>
      {{ "profile.add_service" | translate }}
    </button>
  </div>

  <app-load-error *ngIf="loadError" [message]="'profile.listino.load_error' | translate" (retry)="load()"></app-load-error>

  <!-- Stato vuoto -->
  <div class="listino-empty" *ngIf="loaded && !loadError && services.length === 0">
    <div class="empty-icon"><app-icon name="sparkle" [size]="40"></app-icon></div>
    <h3>{{ "profile.no_services" | translate }}</h3>
    <p>{{ "profile.no_services_desc" | translate }}</p>
    <button class="btn-gold" (click)="addService()">
      {{ "profile.add_service_btn" | translate }}
    </button>
  </div>

  <!-- Lista servizi -->
  <div class="service-list" *ngIf="services.length > 0">
    <div *ngFor="let s of services; let i = index" class="service-card">
      <!-- READ MODE: tocca la riga per modificare -->
      <div *ngIf="editingServiceIndex !== i" class="service-row">
        <button type="button" class="service-info" (click)="editingServiceIndex = i">
          <span class="service-name">{{ s.name }}</span>
          <span class="service-desc" *ngIf="s.description">{{ s.description }}</span>
        </button>
        <div class="service-right">
          <span class="service-price" *ngIf="!isDiscounted(s)">€ {{ s.price | number: "1.2-2" }}</span>
          <span class="service-price-wrap" *ngIf="isDiscounted(s)">
            <span class="service-price-old">€ {{ s.price | number: "1.2-2" }}</span>
            <span class="service-price">€ {{ s.discount.price | number: "1.2-2" }}</span>
            <span class="service-discount-until"><ng-container *ngIf="s.discount.name">{{ s.discount.name }} · </ng-container>{{ "profile.service_discount_badge" | translate }} {{ s.discount.until | date: "dd/MM/yyyy" }}</span>
          </span>
          <label class="toggle-switch" [title]="'profile.available' | translate">
            <input
              type="checkbox"
              [(ngModel)]="s.default_active"
              (change)="saveServices()"
              [attr.aria-label]="'profile.available' | translate"
            />
            <span class="toggle-slider"></span>
          </label>
          <button
            type="button"
            class="btn-edit-icon"
            (click)="editingServiceIndex = i"
            [attr.aria-label]="'profile.edit_btn' | translate"
          >
            <app-icon name="edit" [size]="16"></app-icon>
          </button>
        </div>
      </div>

      <!-- EDIT MODE -->
      <div *ngIf="editingServiceIndex === i" class="service-edit">
        <div class="service-name-group">
          <input
            type="text"
            [(ngModel)]="s.name"
            [placeholder]="'profile.service_name_placeholder' | translate"
          />
          <div class="price-input">
            <span class="price-symbol">€</span>
            <input
              class="no-spin"
              type="number"
              [(ngModel)]="s.price"
              placeholder="0"
              min="0"
              step="0.01"
              inputmode="decimal"
            />
          </div>
        </div>
        <div class="service-field">
          <label>{{ "profile.service_desc_label" | translate }}</label>
          <input
            type="text"
            [(ngModel)]="s.description"
            [placeholder]="'profile.service_desc_placeholder' | translate"
          />
        </div>
        <div class="service-field discount-field">
          <label class="discount-toggle">
            <span>{{ "profile.service_discount_toggle" | translate }}</span>
            <span class="toggle-switch">
              <input
                type="checkbox"
                [ngModel]="s.discount?.active"
                (ngModelChange)="toggleDiscount(s, $event)"
              />
              <span class="toggle-slider"></span>
            </span>
          </label>
          <div class="discount-inputs" *ngIf="s.discount?.active">
            <div class="service-field discount-name">
              <label>{{ "profile.service_discount_name" | translate }}</label>
              <input
                type="text"
                [(ngModel)]="s.discount.name"
                [placeholder]="'profile.service_discount_name_placeholder' | translate"
              />
            </div>
            <div class="service-field">
              <label>{{ "profile.service_discount_price" | translate }}</label>
              <div class="price-input">
                <span class="price-symbol">€</span>
                <input
                  class="no-spin"
                  type="number"
                  [(ngModel)]="s.discount.price"
                  placeholder="0"
                  min="0"
                  step="0.01"
                  inputmode="decimal"
                />
              </div>
            </div>
            <div class="service-field">
              <label>{{ "profile.service_discount_until" | translate }}</label>
              <input type="date" [(ngModel)]="s.discount.until" />
            </div>
          </div>
        </div>
        <div class="service-actions">
          <button class="btn-gold" (click)="saveServiceItem(i)">
            {{ "profile.save" | translate }}
          </button>
          <button class="btn-cancel" (click)="cancelEdit(i)">
            {{ "profile.cancel" | translate }}
          </button>
          <button type="button" class="btn-delete-service" (click)="removeService(i)">
            <app-icon name="trash" [size]="15"></app-icon>
            {{ "common.delete" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

</div>
